// import styled from '@emotion/styled';
import { Field, FieldProps } from 'formik';
import React from 'react';
import {
  FileUploadProperty,
  FormPageInputData,
  FormPageInputItemFileUploadPiclib,
} from 'shared';
import { FormFieldProps } from '../shared';
import { FileUploadPiclib } from './FileUploadPiclib';
import { useFileUploadHandler } from './useFileUploadHandler';

type Props = FormFieldProps<FileUploadProperty>;

const Container: React.FC<
  Props & {
    fieldProps: FieldProps<
      FormPageInputItemFileUploadPiclib,
      FormPageInputData
    >;
  }
> = ({ fieldProps, property, design, disabled, submitted }) => {
  const {
    onSelect,
    onDelete,
    onChange,
    onReload,
    displayError,
    sessionError,
    errorMessages,
    status,
    thumbnail,
    reloading,
  } = useFileUploadHandler({
    property,
    fieldProps,
    submitted,
  });

  if (fieldProps.field.value == null) {
    return null;
  }

  return (
    <FileUploadPiclib
      property={property}
      design={design}
      disabled={disabled || sessionError || reloading}
      onSelect={onSelect}
      onChange={onChange}
      onDelete={onDelete}
      onReload={onReload}
      errorMessages={errorMessages}
      displayError={displayError || sessionError}
      status={status}
      thumbnail={thumbnail}
    />
  );
};

export const FileUpload: React.FC<Props> = (props) => {
  return (
    <Field name={props.property.propertyId}>
      {(fieldProps: FieldProps<FormPageInputItemFileUploadPiclib>) => (
        <Container {...props} fieldProps={fieldProps} />
      )}
    </Field>
  );
};
